<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        {{ popupTitle }}
      </h3>

      <validation-observer ref="document-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <label for="name">Name:</label>
              <d-input
                v-model="data.name"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="serial_number"
              v-slot="{ errors }">
              <label for="name">Serial number:</label>
              <d-input
                v-model="data.serial_number"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="name">Nationality:</label>
            <div :class="{
              'form-control': true,
              'is-select': true
            }">
              <v-select
                :options="countriesOptions"
                v-model="data.country_id"
                :reduce="country => country.id"
                placeholder="Select a nationality"
                :multiple="false"
                label="text">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.text }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.iso_a3 }}
                  </div>
                </template>
                <template slot="no-options">
                  There are no nationalities for the provided phrase&hellip;
                </template>
              </v-select>
            </div>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="country_id">Country:</label>

            <validation-provider
              rules="required"
              name="country_id"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                <v-select
                  :options="countriesOptions"
                  v-model="data.countries"
                  :reduce="country => country.id"
                  placeholder="Select a country"
                  :multiple="true"
                  label="text">
                  <template slot="no-options">
                    There are no countries for the provided phrase&hellip;
                  </template>
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="expiry">Expiry:</label>
            <d-datepicker
              v-model="data.expiry"
              format="dMMMyy"
              placeholder="Select a date" />
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import CommonGetters from './../../utils/CommonGetters.js';
import DateUtils from './../../utils/DateUtils.js';
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'DocumentPopup',
  computed: {
    popupTitle () {
      if (this.mode === 'add') {
        if (this.documentType === 'documents-licences') {
          return 'Add license';
        }

        if (this.documentType === 'passports') {
          return 'Add passport';
        }

        return 'Add document';
      }

      if (this.documentType === 'documents-licences') {
        return 'Edit license';
      }

      if (this.documentType === 'passports') {
        return 'Edit passport';
      }

      return 'Edit document';
    },
    documentName () {
      if (this.documentType === 'documents-licences') {
        return 'license';
      }

      if (this.documentType === 'passports') {
        return 'passport';
      }

      return 'document';
    },
    countriesOptions () {
      return CommonGetters.getCountriesForSelect(this.countries);
    }
  },
  data () {
    return {
      isVisible: false,
      mode: 'add',
      loading: false,
      triggerAddPaxCrewAfterSave: false,
      documentType: 'documents',
      countries: [],
      loadedCountries: false,
      loadError: false,
      data: {
        id: false,
        is_default: false,
        name: '',
        serial_number: '',
        nationality: '',
        countries: null,
        expiry: null,
        reference_type: null,
        reference_id: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-document-popup', this.show);
    this.$bus.$on('countries-list-reload', this.loadAdditionalData);
    this.loadAdditionalData();
  },
  methods: {
    show (mode, referenceType = false, referenceId = false, documentId = false, documentType = 'documents', triggerAddPaxCrewAfterSave = false) {
      this.mode = mode;

      if (mode === 'add') {
        this.loading = false;
        this.data = {
          id: false,
          name: '',
          default: false,
          serial_number: '',
          nationality: '',
          countries: null,
          expiry: null,
          reference_type: referenceType,
          reference_id: referenceId
        };
        this.triggerAddPaxCrewAfterSave = triggerAddPaxCrewAfterSave;
        this.documentType = documentType;
      } else {
        this.loading = true;
        this.documentType = documentType;
        this.loadDocumentData(documentId);
      }

      setTimeout(() => {
        this.$refs['document-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/countries/items',
        params: {
          pagination: 0
        },
        loadedKey: 'loadedCountries',
        outputKey: 'countries',
        errorKey: 'loadError'
      });
    },
    loadDocumentData (documentId) {
      FormUtils.loadItemData(this, {
        id: documentId,
        endpointBase: '/' + this.documentType + '/item/',
        instanceFields: ['id', 'name', 'serial_number', 'nationality', 'country_id', 'expiry', 'countries', 'is_default', 'reference_type', 'reference_id'],
        loadedKey: 'loaded',
        successAction: () => {
          this.loading = false;
          this.data.is_default = !!this.data.is_default;

          if (this.data.countries) {
            this.data.countries = this.data.countries.map(country => country.id);
          }

          this.data = DateUtils.groupConversionStringToDate(this.data, ['expiry']);
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['document-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/' + this.documentType + '/store';

      if (this.mode === 'edit') {
        endpointUrl = '/' + this.documentType + '/update/' + this.data.id;
      }

      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.mode === 'add' ? this.documentName + ' added' : this.documentName + ' saved',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the ' + this.documentName + '. Please try again.',
        successAction: (response) => {
          if (this.mode === 'add' && response.success && this.triggerAddPaxCrewAfterSave) {
            this.$bus.$emit('pax-list-add-item-with-document', {
              itemType: this.data.reference_type,
              itemID: this.data.reference_id,
              documentID: response.item.id,
              documentData: response.item
            });
          }

          this.triggerAddPaxCrewAfterSave = false;
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('documents-list-reload', this.documentType);
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
      this.triggerAddPaxCrewAfterSave = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
      this.triggerAddPaxCrewAfterSave = false;
    },
    prepareFormData () {
      this.data = DateUtils.groupConversionDateToString(this.data, ['expiry']);

      let dataToSend = {
        name: this.data.name,
        country_id: this.data.country_id,
        is_default: this.data.is_default,
        expiry: this.data.expiry,
        countries: this.data.countries,
        serial_number: this.data.serial_number,
        reference_type: this.data.reference_type,
        reference_id: this.data.reference_id
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-document-popup', this.show);
    this.$bus.$off('countries-list-reload', this.loadAdditionalData);
  }
}
</script>
